<template>
<div>
  <div>
    <img src="/static/img/bg_beiruan.png" />
  </div>
    <cur-location :location="location"/>
<div class="article">
	<div class="container">
		<div class="list">
			<ul> 
				<li class="clearfix" v-for="(article ,index) in articles" :key="index">
					<img class="artImg" v-if="article.picsrc" :src="`${global.remoteIp}/uploads/${article.picsrc}`"/>
					<div class="title" :style="article.picsrc?'':'width: 1200px;'">
						 <p class="titlep"><router-link :to="`/news/info/${article.plateid}/${article._id}`">{{article.title}}</router-link></p>
             
             <p class="titled"><router-link :to="`/news/info/${article.plateid}/${article._id}`" style="    white-space: break-spaces;">{{article.description}}</router-link></p>
             <p style="    margin-top: 20px;"> <span class="date"><i class="el-icon-time"></i> {{article.addtime.slice(0,10)}}</span> <span class="date">&nbsp;&nbsp;&nbsp;<i class="el-icon-view"></i> {{article.artvisits}}</span>
             <span class="writer">作者： {{article.writer}}</span></p>
					</div>
         
				</li>
      </ul>
			<el-pagination
            style="text-align: center;
    margin-top: 30px;"
              @current-change="toPage"
              @prev-click="toPage"
              @next-click="toPage"
              :page-size="15"
              layout="total, prev, pager, next, jumper"
              :total="intTotal">
            </el-pagination>
            
		</div>
	</div>
</div>
</div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
import CurLocation from "../components/PublicComs/CurLocation.vue";
import RightNews from "../components/PublicComs/RightNews.vue";
const rate= window.innerWidth/1240;
export default {
  metaInfo: {
    meta: [
      { name:'viewport', content:
      `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
    ]
  },
  props: {
    plates: Array,
  },
  components: { CurLocation, RightNews },
  data() {
    return {
      global,
      intTotal: 20,
      intCurrent: 1,
      articles: [],
      location: {
        name: "",
        link: "",
        type: "views",
      },
      Groups: [
        {
          name: "公示公告",
        },
        {
          name: "行业动态",
        },
      ],
      plateId: "",
      isPhone: global.isPhone(),
      latestNews:[],
      navs:[]
    };
  },

  methods: {
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    toPage(intcount) {
      this.toTop();
      this.intCurrent = intcount;
      if (this.plateId == "search") {
        this.$axios
          .get(
            `/api/articles?title=$regex:${this.$route.query.keyWords}&page=${
              this.intCurrent
            }&limit=15`
          )
          .then((res) => {
            if (res.data) {
              this.intTotal = res.data.total;
              this.articles = res.data.data;
            }
          });
        return;
      }
      this.$axios
        .get(
          `/api/articles?plateid=${this.plateId}&page=${
            this.intCurrent
          }&limit=10&sort=-createdAt`
        )
        .then((res) => {
          if (res.data) {
            this.articles = res.data.data;
          }
        });
      
    },
    getaddtime(article) {
      if (!article.addtime) {
        let addtime = article.createdAt;
        let date = new Date(addtime);
        return `${date.getFullYear()}-${("00" + (date.getMonth() + 1)).slice(
          -2
        )}-${("00" + date.getDate()).slice(-2)} ${(
          "00" + date.getHours()
        ).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${(
          "00" + date.getSeconds()
        ).slice(-2)}`;
      } else {
        return article.addtime;
      }
    },
  },
  beforeUpdate() {
    this.toTop();
  },
  beforeDestroy() {
    this.toTop();
  },
  computed: {},
  beforeRouteUpdate(to, from, next) {
    next();
    //路由后的操作
    let plateId = this.$route.params.plateId;
    this.plateId = plateId;
    if (plateId == "search") {
      this.location.name = "搜索结果";
      this.location.link = `/news/views/search`;
      return;
    }
    this.location.link = `/news/views/${plateId}`;
    let plates = this.plates;
    for (let i = 0; i < plates.length; i++) {
      if (plateId == plates[i]._id) {
        this.location.name = plates[i].name;
        break;
      }
    }
    this.$axios
      .get(
        `/api/articles?plateid=${plateId}&page=${
          this.intCurrent
        }&limit=10&sort=-createdAt`
      )
      .then((res) => {
        if (res.data) {
          this.intTotal = res.data.count;
          this.articles = res.data.data;
        }
      });
  },
  mounted() {
this.$axios
        .get(
          `/api/articles?limit=10&sort=-createdAt`
        )
        .then((res) => {
          if (res.data) {
            console.log(res.data.data)
            this.latestNews = res.data.data;
          }
        });
    let plateId = this.$route.params.plateId;
    this.plateId = plateId;
    if (plateId == "search") {
      this.$axios
        .get(
          `/api/articles?title=$regex:${this.$route.query.keyWords}&page=${
            this.intCurrent
          }&limit=10&sort=-createdAt`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.articles = res.data.data;
          }
        });
      this.location.name = "搜索结果";
      this.location.link = `/news/views/search`;
    } else {
      this.location.link = `/news/views/${plateId}`;
      let plates = this.plates;
      for (let i = 0; i < plates.length; i++) {
        if (plateId == plates[i]._id) {
          this.location.name = plates[i].name;
          break;
        }
      }
      this.$axios
        .get(
          `/api/articles?plateid=${plateId}&page=${
            this.intCurrent
          }&limit=10&sort=-createdAt`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.articles = res.data.data;
          }
        });
        
    }
    for (let k = 0; k < this.Groups.length; k++) {
      for (let j = 0; j < this.plates.length; j++) {
        if (this.Groups[k].name == this.plates[j].name) {
          this.Groups[k].plateId = this.plates[j]._id;
          this.$axios
            .get(
              `/api/articles?plateid=${this.Groups[k].plateId}&sort=-createdAt`
            )
            .then((res) => {
              if (res.data) {
                this.Groups[k].articles = this.global
                  .sortByTop(res.data.data)
                  .slice(0, 6);
                this.$forceUpdate();
                //  watchflag++;
                //  (watchflag==this.Groups.length)&&this.$nextTick(function(){
                //       watchflag = true;
                //       $('.tab-num01 #tab li').click(function(){
                //         $(this).addClass('tab-current').siblings().removeClass('tab-current');
                //         $('.tab-num01 #tab-content>section:eq('+$(this).index()+')').show().siblings().hide();
                //       });
                //   })
              }
            });
          break;
        }
      }
    }
  },

  watch: {},
};
</script>
<style scoped>
.article .list .title{
  position: relative;
  display: inline-block;
  width: 918px;
      height: 158px;
  margin-right:0px;
  margin-left: 20px;
}
.artImg{
      width: 262px;
    height: 158px;
    
    position: relative;
    display: inline-block;
}
.article .list li{
  padding: 0;
  margin-bottom: 41px;
  background: #FAFAFA;
}
.titlep{
      font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
}
.titled {
  font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
    line-height: 11px;
    margin-top: 12px;
}
.article .list .date{
  font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #BDBDBD;
    float: initial;
}
.article .list .writer{
   font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #BDBDBD;
    float: right;
    margin-right: 20px;
}
</style>
